import React, { Fragment } from 'react';
import { css, cx } from '@linaria/atomic';
import { theme } from '@frontend/theme';
import { CaretRightIconSmall } from '../../icon/icons-small/caret-right-small';
import { BreadcrumbPath } from './breadcrumb-path';

const BREADCRUMB = css`
  display: flex;
  flex-direction: row;
  align-items: center;

  span:first-of-type {
    cursor: pointer;
  }

  > p,
  > a {
    margin: 0;
  }

  > a:hover,
  > a:focus {
    color: ${theme.colors.primary50};
  }
`;

const BREADCRUMB_SEPARATOR = css`
  margin: ${theme.spacing(0, 2)};
  color: ${theme.colors.neutral50};
`;

type BreadcrumbProps = {
  children: React.ReactElement[];
  className?: string;
};

export const Breadcrumb = ({ children, className, ...rest }: BreadcrumbProps) => {
  return (
    <div className={cx(BREADCRUMB, className)} {...rest}>
      {children.map((child, i) => {
        if (i !== 0 && child) {
          return (
            <Fragment key={i}>
              <CaretRightIconSmall className={BREADCRUMB_SEPARATOR} />
              {child}
            </Fragment>
          );
        }
        return child;
      })}
    </div>
  );
};

Breadcrumb.Path = BreadcrumbPath;
